module.exports = {
  "country": "PL",
  "artist": "Michal Szpak",
  "song": "Color of your LIve",
  "year": "2016",
  "place": "8",
  "spotify": "1zBK0FGAcAGCxAxO6jC680"
};